// extracted by mini-css-extract-plugin
module.exports = {"icon":"NotificationMenuSwitch_icon__1kBMm","navigationButton":"NotificationMenuSwitch_navigationButton__1ukVu","buttonWrapper":"NotificationMenuSwitch_buttonWrapper__JYqsk"};